import React, { ComponentType, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useRecoilState, useRecoilValue } from 'recoil';
import useSWR from 'swr';

import { API_ROUTES } from 'lib/api-routes';
import { UserResponse } from 'lib/models/user';
import { get } from 'lib/utils/http';
import { PAGE_ROUTES } from 'lib/page-routes';
import { userState } from 'lib/atoms/userAtom';
import { httpHeadersState, userSecretState } from 'lib/atoms/userSecretAtom';

export function withAuth<T>(Component: ComponentType<T>): ComponentType<T> {
  return (hocProps: T) => {
    const router = useRouter();
    const [userSecret, setUserSecret] = useRecoilState(userSecretState);
    const [user, setUser] = useRecoilState(userState);
    const { headers } = useRecoilValue(httpHeadersState);

    const { data: userResponse, error } = useSWR<UserResponse>(
      userSecret ? [API_ROUTES.USER_INFO, headers] : null,
      get
    );

    useEffect(() => {
      if (!userSecret) router.replace(PAGE_ROUTES.SIGN_IN);
    }, [userSecret]);

    useEffect(() => {
      if (error) setUserSecret(null);
    }, [error]);

    useEffect(() => {
      if (userResponse?.data) {
        setUser(userResponse.data);
      }
    }, [userResponse]);

    if (user) {
      return <Component {...hocProps} />;
    } else {
      return null;
    }
  };
}
